/*
  **************************************************************************
  common js
  **************************************************************************
*/

import api from '../../api/index'
import xlsx from 'xlsx'

const common = {};

const account = JSON.parse(localStorage.getItem('account'));
console.log('this.account---------->', account);

// config
common.config = {
    appId: '',
};

// 获取窗口尺寸
common.content = {
    width: window.innerWidth,
    height: window.innerHeight,
};

// 性别
common.sex = [
    {value: 1, name: '先生', text: '男'},
    {value: 2, name: '女士', text: '女'},
    {value: 3, name: '未说明', text: '未说明'},
];

// 证件
common.certificate = [
    {value: 1, name: '身份证'},
    {value: 2, name: '护照'},
    {value: 3, name: '其他'},
];

// 学历
common.education = [
    {value: "1", name: '研究生'},
    {value: "2", name: '大学本科'},
    {value: "3", name: '大学专科和专科学校'},
    {value: "4", name: '中等专业学校'},
    {value: "5", name: '技工学校'},
    {value: "6", name: '高中'},
    {value: "7", name: '初中'},
    {value: "8", name: '小学'},
    {value: "9", name: '文盲或半文盲'},
    {value: "10", name: '不详'},
];

// 职业
common.occupation = [
    {value: "0", name: '国家机关、党群组织、企业、事业单位负责人'},
    {value: "1", name: '专业技术人员'},
    {value: "2", name: '办事人员和有关人员'},
    {value: "3", name: '商业、服务业人员'},
    {value: "4", name: '农、林、牧、渔、水利业生产人员'},
    {value: "5", name: '生产、运输设备操作人员及有关人员'},
    {value: "6", name: '军人'},
    {value: "7", name: '不便分类的其他从业人员'},
    {value: "8", name: '无职业'},
];

// 纬度
common.dimension = [
    { value: 1, name: '情绪指数'},
    { value: 2, name: '心理健康'},
    { value: 3, name: '空间认知能力'},
    { value: 4, name: '逻辑推理能力'},
    { value: 5, name: '脑健康'},
    { value: 6, name: '言语理解能力'},
    { value: 7, name: '执行能力'},
    { value: 8, name: '注意力'},
    { value: 9, name: '认知指数'},
];

/**
 * 验证是否管理员
 * @returns {boolean}
 */
common.isAdmin = ()=> {
    if (account && account.roleId === 0){
        return true;
    }
    return false;
};

/**
 * 验证是否合法手机号
 * @param data
 */
common.isPhoneNumber = (data)=> {
    // debugger
    let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8,6]|8[0-9]|9[1,8,9])\d{8}$/;
    if (!reg.test(data) || !data.length === 11) {
        return false;
    } else {
        return true;
    }
};

/**
 * 验证只能输入英文字母和数字
 * @param data
 */
common.isEnglishNumber = (data)=> {
    debugger
    // var obj = document.form1.txtName.value;
    if(/.*[\u4e00-\u9fa5]+.*$/.test(data)) {
        return false;
    } else {
        return true;
    }
};

/**
 * 取两个集合的交集
 * @param a
 * @param b
 * @returns 结果集合
 */
common.intersect = (a, b)=> {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => set2.has(x)))];
};
common.intersectArray = (a, b)=> {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => set2.has(x)))];
};
common.difference = (a, b)=> {
    let set1 = new Set(a), set2 = new Set(b);
    return [...new Set([...set1].filter(x => !set2.has(x))), ...new Set([...set2].filter(x => !set1.has(x)))];
};

/**
 * 是否有权限
 * @param permissions 权限功能集
 * @returns {boolean}
 */
common.permissions = (data)=> {
    // debugger
    if (account.userId === 1 || common.isAdmin()){
        return true;
    }
    return account && account.permissions ? !!common.intersect(data, account.permissions).length : false;
};

// 根据生日计算年龄
common.age = (data)=> {
    if (!data) return;
    //当前时间 毫秒
    let time = new Date().getTime();
    //一年毫秒数(365 * 86400000 = 31536000000)
    return Math.ceil((time - data) / 31536000000) - 1;
};


/**
 * 数组排序
 * @param array 数组
 * @param data 排序关键字
 * @param kind 排序类型
 * @returns {function(*, *): number}
 */
common.sorting = (array, data, kind)=> {
    // 升序
    if (kind === 'upon'){
        array.sort((a, b)=> {
            return a[data] - b[data]
        });
    }
    // 降序
    if (kind === 'down'){
        array.sort((a, b)=> {
            return b[data] - a[data];
        });
    }
    return array;
};

/**
 * 将 file 转换为 BASE64
 * @param data
 * @returns {string|boolean}
 */
common.fileToBase = function (data) {
    if (!data || data === ''){
        return false;
    }
    let reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = function (e) {
        data.url = reader.result;
    };
    console.log(data.url);
    return data;
};

/**
 * 截取文件后缀名
 * @param data
 */
common.fileExtensionName = function (data) {
    //获取文件名，不带后缀
    var fileName = data;

    var strFileName = fileName.replace(/(.*\/)*([^.]+).*/ig, "$2");

    // 获取文件后缀
    var FileExt = fileName.replace(/.+\./, "");
    var fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

    //截取文件后缀
    var reg = /\.\w+$/;
    var file_name = fileName.replace(reg, '');

    return fileExtension;
};

/**
 * 判断文件类型
 */
common.assetsFilesType = (data)=> {
    let image = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
    let video = ["mp4", "m2v", "mkv"];
    if (image.indexOf(common.fileExtensionName(data)) !== -1){
        return 1; // 图片类
    }
    if (image.indexOf(common.fileExtensionName(data)) !== -1){
        return 2; // 文件类
    }
    if (video.indexOf(common.fileExtensionName(data)) !== -1){
        return 3; // 视频类
    }
    return 4; // 其他类型
};

/**
 * 验证是否合法URL
 * @param URL
 * @returns {boolean}
 */
common.isCheckedURL = function (URL) {
    let http = URL,
        Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
        objExp = new RegExp(Expression);
    if (objExp.test(http) === true) {
        return true;
    } else {
        return false;
    }
};

// 获取所有启用的用户
common.getEnableUser = async ()=> {
    // debugger
    let res = await api.getHttp('test/user/list?page=1&pageSize=1000000&status=1');
    if (res.data.code !== 0){
        throw new Error(res.data.msg);
    }
    let array = res.data.data.rows;
    for (let i = 0; i < array.length; i++) {
        let avatar = '';
        if (array[i].avatar && array[i].avatar !== ''){
            avatar = (api.resHttp().target + array[i].avatar);
        } else {
            avatar = 'static/avatar.png';
        }
        array[i].key = array[i].id;
        array[i].label = array[i].name;
        array[i].avatar = avatar;
        array[i].disabled = false;
    }
    return array;
};

/**
 * 操作任务
 * @param data 当前用户
 * @param kind 操作类型 1添加 2编辑
 * @param page 当前页面
 * @param tips 是否需要提示
 * @returns {Promise<unknown>}
 */
common.task = async (data, kind, page)=> {
    debugger
    if (!page || page === '') return;

    if (page === 'user'){
        let name = (window.vue.$moment(new Date().getTime()).format('YYYY-MM-DD-HH-mm-ss')).replace(/-/g, '');
        data.taskName = data.name + name;
        data.beginTime = new Date().toLocaleDateString();
        data.endTime = new Date().toLocaleDateString();
    }

    if (!data.taskName || data.taskName === ''){
        await common.alertModel('warning', '任务名称不能为空');
        return false;
    }
    if (!data.scale || data.scale === ''){
        await common.alertModel('warning', '任务类型不能为空');
        return false;
    }
    if (!data.beginTime || data.beginTime === ''){
        await common.alertModel('warning', '开始时间不能为空');
        return false;
    }
    if (!data.endTime || data.endTime === ''){
        await common.alertModel('warning', '结束时间不能为空');
        return false;
    }

    let beginTime = new Date(data.beginTime).getTime();
    let endTime = new Date(data.endTime).getTime();
    if (beginTime > endTime){
        await common.alertModel('warning', '开始时间不能大于结束时间');
        return false;
    }
    // if (endTime <= new Date().getTime()){
    //     await common.alertModel('warning', '结束时间不能小于当前时间');
    //     return false;
    // }

    data.beginTime = beginTime;
    data.endTime = endTime;
    if (page === 'user'){
        data.testUserIds = [data.id].toString();
    }
    if (page === 'task'){
        if (!data.testUserIds || data.testUserIds.length === 0){
            await common.alertModel('warning', '测评用户不能为空');
            return false;
        }
        data.testUserIds = data.testUserIds.join(',');
    }

    let res;
    if (kind === 1){
        res = await api.postHttp('task/add', data);
    }
    if (kind === 2){
        res = await api.putHttp('task/edit', data);
    }
    console.log('this.onConfirm---------->', res);
    if (res.data.code !== 0){
        await common.alertModel('error', res.data.msg);
        return false;
    }
    localStorage.setItem('task', JSON.stringify(res.data.data));
    if (page === 'user'){
        return res.data.data;
    }
    if (page === 'task'){
        window.vue.$Message.success(res.data.msg);
        return true;
    }
};

common.device = async ()=> {
    let res = await $api.getHttp('device/own/device?type=2');
    console.log('common.device---------->', res);
    if (res.data.code !== 0){
        return window.vue.$Message.error(res.data.msg);
    }
    return res.data.data;
};

/**
 * 查询用户详情
 * @param uid
 * @returns {Promise<{}>}
 */
common.getUser = async (uid) => {
    if (!uid || uid === '') return;
    let res = await api.getHttp('test/user/parents?testUserId=' + uid);
    // console.log('common.getUser---------->', res);
    return res.data.data || {};
}

// 下载文件
common.download = async (data, field)=> {
    if (!data || !field) return;
    let href = api.resHttp().download + data[field];
    let tags = document.createElement("a");
        tags.style.display = "none";
        tags.href = href;
    document.body.appendChild(tags);
        tags.click();
    document.body.removeChild(tags);
};

/**
 * 更新member数据
 * @param memberId
 * @returns {Promise<boolean|*>}
 */
common.updateMember = async (memberId)=> {
    let res = await api.getHttp('member/update?memberId=' + memberId);
    // debugger
    if (res.data.code !== 0){
        common.alertModel('warning', res.data.msg);
        return false;
    }
    account.member = res.data.data;
    if (account.member.businessName === ''){
        account.member.businessName = account.memberUser.realName;
    }
    localStorage.setItem('account', JSON.stringify(account));
    window.vue.$store.state.account = account;
    return res.data.data;
};

/**
 * 数据导出为xlsx
 * @param title 首行表头
 * @param data 需要导出的数据
 * @param file 导出的文件名
 * @returns {Promise<void>}
 */
common.exportExcel = async (title, data, file)=> {
    if (!data || data.length === 0){
        await window.vue.$common.alertModel('导出数据不能为空');
        return false;
    }
    if (!file || file === ''){
        await window.vue.$common.alertModel('导出数据的文件名不能为空');
        return false;
    }
    let tableData = [title];
    for (let i = 0; i < data.length; i++){
        tableData.push(data[i]);
    }
    // 处理数据
    const workSheet = xlsx.utils.aoa_to_sheet(tableData);
    const workBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workBook, workSheet, file);

    // 导出的excel表的名字
    xlsx.writeFile(workBook, file + '.xlsx');
};

/**
 * 提示框 confirmModel
 * @param content
 * @returns {Promise<unknown>}
 */
common.confirmModel = function (content, option) {
    return new Promise(((resolve, reject) => {
        window.vue.$Modal.confirm({
            title: '系统提示',
            content: content,
            okText: option && option.okText ? option.okText : '确定',
            onOk: () => {
                resolve(true);
            },
            onCancel: () => {
                resolve(false);
            },
        })
    }));
};

common.alertModel = function (type, content) {
    let title = '系统提示';
    return new Promise(((resolve) => {
        if (type === 'info'){
            window.vue.$Modal.info({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'success'){
            window.vue.$Modal.success({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'warning'){
            window.vue.$Modal.warning({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
        if (type === 'error'){
            window.vue.$Modal.error({
                title: title,
                content: content,
                onOk: () => {
                    resolve()
                }
            })
        }
    }))
};

export default common;



// WEBPACK FOOTER //
// ./src/assets/js/common.js